<template lang="pug">
  div
    el-col(:span="12")
      app-display(
        id="ENDERECO_LOGRADOURO"
        label="Logradouro:",
        :content="endereco.logradouro || '-'"
        :class = "mudouEndereco && mudouEndereco.mudouLogadouro ? 'text': '' "
      )
    el-col(:span="12")
      app-display(
        v-if="endereco.numero !== '-'",
        id="ENDERECO_NUMERO"
        label="Número:",
        :content="getValueNumero(endereco.numero)"
        :class = "mudouEndereco && mudouEndereco.mudouNumero ? 'text': '' "
      )
    el-col(:span="12")
      app-display(
        id="ENDERECO_BAIRRO"
        label="Bairro:",
        :content="endereco.bairro || '-'",
        :marginTopBottom="endereco.complemento !== '' && !!endereco.complemento"
        :class = "mudouEndereco && mudouEndereco.mudouBairro ? 'text': '' "
      )
    el-col(:span="12")
      app-display(
        id="ENDERECO_COMPLEMENTO"
        label="Complemento:",
        :content="getValue(endereco.complemento) || '-'"
        :class = "mudouEndereco && mudouEndereco.mudouComplemento ? 'text': '' "
      )
    el-col(:span="12")
      app-display(
        id="ENDERECO_CEP"
        label="CEP:",
        :content="endereco.cep || '-'"
        :class = "mudouEndereco && mudouEndereco.mudouCEP ? 'text': '' "
      )
    el-col(:span="12")
      app-display(
        id="ENDERECO_UF"
        label="UF:",
        :content="endereco.municipio.estado || endereco.municipio.codigoEstado || endereco.municipio.estadoCod"
        :class = "mudouEndereco && mudouEndereco.mudouUF ? 'text': '' "
      )
    el-col(:span="12")
      app-display(
        id="ENDERECO_MUNICIPIO"
        label="Município:",
        :content="getValue(endereco.municipio.nome)"
        :class = "mudouEndereco && mudouEndereco.mudouMunicipio ? 'text': '' "
      )

</template>

<script>
import compararReticacoesDefault from '@/utils/pa/compararReticacoesDefault'
import AppDisplay from '../../AppDisplay'

export default {
  props: {
    endereco: {
      type: Object,
      required: true
    },
    mudouEndereco: {
      type: Object,
      default: compararReticacoesDefault.mudouEnderecoDefault
    }
  },
  components: {
    AppDisplay
  },
  methods: {
    getValue (params) {
      return params || '-'
    },
    getValueNumero (numero) {
      return numero || 'S/N'
    }
  }
}
</script>

<style lang="scss" scoped>
  >>> .text .text{
    color: #ff0000 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/ma/InformacoesEndereco.vue